export default "__VITE_ASSET__GBPRx$VM__"